import { JobSearchQueryInput } from '@xing-com/crate-common-graphql-types';
import type { WindowLocation } from '@xing-com/crate-core-router';
import { useLocation } from '@xing-com/crate-core-router';
import type { JDP_SA_DEFAULT_QUERY } from '@xing-com/crate-jobs-constants';

export type NavigationState = {
  [JDP_SA_DEFAULT_QUERY]?: JobSearchQueryInput;
};

export const useNavigationState = (): NavigationState | undefined => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const { state } = useLocation() as WindowLocation<NavigationState>;
  return state ?? undefined;
};
